import { APIService } from "./APIService";

export const SearchBarTypes = {
    hotels : 'hotels'
}

export default class SearchBarService extends APIService {
    public static getSearchBarByType( type: string, cityUnique: string ): any {
        return this.get<any>( `/proxy/search-bar/${type}/${cityUnique}/`, {
            headers : {
                'x-supports' : 'lmd-optional-date',
                'Accept'     : 'application/vnd.search-bar-api.v4+json'
            }
        } );
    }

    public static updateSearchBar( type: string, cityUnique: string, data: any, dryRun: boolean = false ): any {
        return this.post<any, any>( `/search-bar/${type}/${cityUnique}/`, data, {
            params: {
                dryRun: dryRun ?? false
            },
            headers : {
                'Content-Type' : 'application/json',
                'x-supports'   : 'lmd-optional-date'
            }
        } );
    }
}
